import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./Button.module.css";

export type ButtonVariant = "primary" | "secondary" | "soft" | "subtle" | "danger";

function classes(variant: ButtonVariant, small: boolean, className?: string): string {
  return [styles.button, styles[variant], small && styles.small, className]
    .filter(Boolean)
    .join(" ");
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  small?: boolean;
}

export function Button({
  variant = "secondary",
  small = false,
  className,
  type = "button",
  children,
  ...rest
}: ButtonProps): ReactNode {
  return (
    // eslint-disable-next-line react/button-has-type -- defaulted above
    <button type={type} className={classes(variant, small, className)} {...rest}>
      {children}
    </button>
  );
}

export interface LinkButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: ButtonVariant;
  small?: boolean;
}

/**
 * A button that is really a navigation. Sign-in is the case that matters: the
 * login endpoint 302s to Keycloak, and fetching it would follow that redirect
 * into a CORS wall — so it has to be a real anchor the browser navigates.
 */
export function LinkButton({
  variant = "primary",
  small = false,
  className,
  children,
  ...rest
}: LinkButtonProps): ReactNode {
  return (
    <a className={classes(variant, small, className)} {...rest}>
      {children}
    </a>
  );
}
